/**
 * List of disallowed property names that needs
 * to be obfuscate out before being logged
 */

module.exports = [
  'authorization',
  'canceltoken',
  'maxcontentlength',
  'transfer-encoding',
  'content-encoding',
  'cache-control',
  'transformrequest',
  'transformresponse',
  'password',
  'email',
  'useremail',
  'user_email',
  'user_metadata',
  'data',
  'geoip',
  'picture',
  'name',
  'first_name',
  'last_name',
  'birth_year',
  'birth_month',
  'birth_day',
  'firstname',
  'lastname',
  'birthyear',
  'birthmonth',
  'birthday',
  'phone',
  'country_code',
  'countrycode',
  'gender',
  'nickname',
  'mailchimp',
  'agreement_country',
  'agreementcountry',
  'disclaimer_country',
  'disclaimercountry',
  'country',
  'address',
  'client_id',
  'user_name',
  'auth',
  'ip',
  'last_ip',
  'eduPersonPrincipalName',
  'urn.*',
  'geoipCountryName',
  'ipAddr',
  '_header',
  'values',
  'username',
  'txtUserName',
  'txtPassword'
];
